
<main-form-modal (toggleChange)="setVal($event)"> 
    <ng-template #customHtmlElements>
        <div [ngSwitch]="editMode">
           
            <payment-edit *ngSwitchCase="true"></payment-edit>
            <payment-details *ngSwitchCase="false"></payment-details>
        </div>
    </ng-template>  
</main-form-modal>